module.exports = __webpack_public_path__ + "img/section2_img.1a01b32c.png";